// Update this with help from https://qr-code-styling.com/

const sizeInPixels     = 500,
      marginInPixels   = 0,
      backgroundColour = '#FFFFFF',
      foregroundColour = '#000000';

const QRCodeStylingOptions = (uploadUrl, imageUrl, options = {}) => {
  const { width = sizeInPixels, height = sizeInPixels } = options;

  return {
    "width": width,
    "height": height,
    "margin": marginInPixels,

    "qrOptions": {
      "typeNumber": "0",
      "mode": "Byte",
      "errorCorrectionLevel": "Q"
    },

    "data": uploadUrl,

    "image": imageUrl,
    "imageOptions": {
      "hideBackgroundDots": true,
      "imageSize": 0.5,
      "margin": 5
    },

    "backgroundOptions": {
      "color": backgroundColour
    },
    "backgroundOptionsHelper": dotOptionsHelper,

    "dotsOptions": dotsOptions,
    "dotsOptionsHelper": dotOptionsHelper,

    "cornersSquareOptions": dotOptions,
    "cornersSquareOptionsHelper": dotOptionsHelper,

    "cornersDotOptions": dotOptions,
    "cornersDotOptionsHelper": dotOptionsHelper
  }
}

const dotOptions = {
  "type": "dot",
  "color": foregroundColour
};

const dotsOptions = {
  "type": "dots",
  "color": foregroundColour
}

const dotOptionsHelper = {
  "colorType": {
    "single": true,
    "gradient": false
  }
};

export default QRCodeStylingOptions;